var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('avue-crud',{attrs:{"data":_vm.tableDatas,"page":_vm.page,"option":_vm.tableOption,"table-loading":_vm.tableLoading},on:{"update:page":function($event){_vm.page=$event},"row-save":_vm.handleSave,"row-update":_vm.handleUpdate,"row-del":_vm.handleDel,"on-load":_vm.onLoad,"refresh-change":_vm.onLoad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }